"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TournamentStatus = void 0;
var TournamentStatus;
(function (TournamentStatus) {
    /**
     * Has a minimum joined teams
     */
    TournamentStatus["Live"] = "live";
    /**
     * Match administrator cancel the tournament
     */
    TournamentStatus["Canceled"] = "canceled";
    /**
     * All players played
     */
    TournamentStatus["Finished"] = "finished";
    /**
     * Waiting on minimum count of joined players
     */
    TournamentStatus["Pending"] = "pending";
    /**
     * Create the game world was failed
     */
    TournamentStatus["Failed"] = "failed";
    /**
     * Checkin phase
     */
    TournamentStatus["Checkin"] = "checkin";
})(TournamentStatus = exports.TournamentStatus || (exports.TournamentStatus = {}));
//# sourceMappingURL=tournament-status.js.map